import React, { useEffect } from "react";  
 
import Header from 'components/Dashboard/Header'
import BottomNav from 'components/Dashboard/BottomNav'

import {
    DashboardPage,
    DashboardBody,
    DashboardBodyContent,
    Content
} from "./styled";
import { ReadObject } from "services/storage";
import { ReadProfiles } from "services/profile";
import { useHistory } from "react-router-dom";

export default function ContainerAuthenticated({ children, primary, page }){

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const init = async () => {
        const authentication = ReadObject('authentication')
        if (!authentication?.jwt) {
            completeNext()
            return;
        }

        // Logado, mas SEM um perfil selecionado? A plataforma não pode ser usada sem
        // perfil (o app Android exige, e o histórico depende dele). Em vez de deixar a
        // pessoa "solta" na área logada, mandamos escolher um perfil — ou criar o primeiro.
        const currentProfile = ReadObject('currentProfile')
        if (!currentProfile?.id) {
            const stored = ReadObject('profiles')
            let hasProfiles = !!(stored && stored.length)
            if (!hasProfiles) {
                const fetched = await ReadProfiles()
                hasProfiles = !!(fetched && fetched.length)
            }
            navigate(hasProfiles ? 'dashboard/select-profile' : 'dashboard/create-profile')
        }
    }

    const completeNext = () => {
        navigate('login')
    }

    useEffect(() => {  
        init() 
    }, [])

    return ( 
        <>
            <Content>
                <DashboardPage>
                    <Header page={page} /> 
                    <DashboardBody> 
                        <DashboardBodyContent primary={primary}>                     
                            { children }
                        </DashboardBodyContent>
                    </DashboardBody>
                </DashboardPage>
            </Content>
            <BottomNav />
        </>
    );
}